import { FormattedMessage } from 'react-intl';
import './SignUpSuccess.scss';

const SignUpSuccess = () => (
  <div className="signupsuccess wrapper container">
    <h1>
      <FormattedMessage
        id="signupsuccess_title"
        defaultMessage="Registration successful"
      />
    </h1>
    <p>
      <FormattedMessage
        id="signupsuccess_subtitle"
        defaultMessage="One more step to your personal cloud"
      />
    </p>
    <p>
      <FormattedMessage
        id="signupsuccess_text"
        defaultMessage="We have just sent you a confirmation mail. After verifying (use the link in the e-mail) you will get your personal cloud in just some minutes!"
      />
    </p>
  </div>
);

export default SignUpSuccess;
